import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconLanguageSvg } from "./IconLanguageSvg.mjs";
const IconLanguage = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconLanguageSvg, ...iconProps });
};
export {
  IconLanguage
};
